import React from 'react';
import './DeleteServer.css';

const Modal = ({ show, onClose, onConfirm, server, isDeleting, deletionResult }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {isDeleting ? (
          <p>Deleting server...</p>
        ) : deletionResult ? (
          <p>{deletionResult}</p>
        ) : (
          <>
            <p>Are you sure you want to delete this server?</p>
            {server && (
              <div>
                <p><strong>Server Name:</strong> {server.name}</p>
                <p><strong>Server Link:</strong> {server.link}</p>
              </div>
            )}
            <div className="modal-buttons">
              <button className="modal-button confirm-button" onClick={onConfirm}>Yes</button>
              <button className="modal-button cancel-button" onClick={onClose}>No</button>
            </div>
          </>
        )}
        {deletionResult && (
          <div className="modal-buttons">
            <button className="modal-button close-button" onClick={onClose}>Close</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
